import { render, staticRenderFns } from "./JigsawLibraryConfig.vue?vue&type=template&id=6489c336"
import script from "./JigsawLibraryConfig.vue?vue&type=script&lang=js"
export * from "./JigsawLibraryConfig.vue?vue&type=script&lang=js"
import style0 from "./JigsawLibraryConfig.vue?vue&type=style&index=0&id=6489c336&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports